import { useState } from 'react';
import { cn } from '@/utils/styles';
import { Skeleton } from '@design-system/Skeleton';

interface ShimmerImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  containerClassName?: string;
  skeletonClassName?: string;
}

export const ShimmerImage = ({ containerClassName, skeletonClassName, className, onLoad, onError, ...imgProps }: ShimmerImageProps) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={cn('relative', containerClassName)}>
      {!loaded && <Skeleton className={cn('absolute inset-0', skeletonClassName)} />}
      <img
        {...imgProps}
        className={cn(className, !loaded && 'opacity-0')}
        onLoad={(e) => {
          setLoaded(true);
          onLoad?.(e);
        }}
        onError={(e) => {
          setLoaded(true);
          onError?.(e);
        }}
      />
    </div>
  );
};
